module.exports = __webpack_public_path__ + "static/img/wxscr2.fd2cb7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxscr2.png
// module id = NIAA
// module chunks = 0